import Post4 from './Post4';

export default Post4;
